angular.module('zc').component('zcDashboardInvoiceChart', {
  templateUrl: '/templates/projects.dashboard/invoice_chart.html',
  bindings: {
    project: '<',
    chart: '<',
  },
  controller: zcDashboardInvoiceChartController
});

zcDashboardInvoiceChartController.$inject = [
  '$scope',
  '$translate',
  '$window',
  'ChartV2',
  'lineChartV2Config'
];
function zcDashboardInvoiceChartController($scope, $translate, $window, ChartV2, lineChartV2Config) {
  const vm = this;

  $scope.$watch('$ctrl.project', project => {
    if(!project || !project.thisMonthStat) return;
    vm.simulation = calculateSimulation();
    vm.predictionAchievementRate = calculatePredictionAchievementRate();
    setChartConfig();
  });

  function calculatePredictionAchievementRate() {
    const thisMonthsInvoicePrice = _.get($scope.$ctrl.project, 'thisMonthInvoice.invoice_price_tax_excluded', 0);
    return thisMonthsInvoicePrice / (thisMonthsInvoicePrice * vm.simulation) * 100;
  }

  function calculateSimulation() {
    const today = moment()
      .add(1, 'day')
      .startOf('day');
    const monthFrom = moment(vm.project.thisMonthStat.start_at).startOf(
      'month'
    );
    const monthTo = moment(vm.project.thisMonthStat.start_at)
      .add(1, 'month')
      .startOf('month');
    const monthDays = monthTo.diff(monthFrom, 'days');
    const currentFrom = moment(vm.project.thisMonthStat.start_at).startOf(
      'day'
    );
    const currentTo = moment.min(monthTo, today);
    const currentDays = currentTo.diff(currentFrom, 'days');
    if(currentDays <= 0) return null;
    return monthDays / currentDays;
  }

  function setChartConfig() {
    const allInvoiceAmounts = [];
    const maxInvoice = [];
    const minimumCharge = [];

    vm.project.dailyReportStats.forEach(stat => {
      const startAt = moment(stat.start_at).valueOf();

      allInvoiceAmounts.push([startAt, stat.invoice_amount]);
      maxInvoice.push([startAt, vm.project.max_invoice]);
      minimumCharge.push([startAt, vm.project.minimum_charge]);
    });

    const chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        labels: { formatter: function() { return `${$window.Highcharts.numberFormat(this.value, 0)} 円` } },
      }],
    });

    chart.addSeries({
      type: 'area',
      name: $translate.instant('projectsDashboard.invoiceChart.allInvoiceAmounts'),
      data: allInvoiceAmounts,
      tooltip: {
        valueSuffix: ' 円',
        valueDecimals: 0,
      },
    });

    chart.addSeries({
      type: 'line',
      name: $translate.instant('projectsDashboard.invoiceChart.maxInvoice'),
      data: maxInvoice,
      tooltip: {
        valueSuffix: ' 円',
        valueDecimals: 0,
      },
    });

    chart.addSeries({
      type: 'line',
      name: $translate.instant('projectsDashboard.invoiceChart.minimunCharge'),
      data: minimumCharge,
      tooltip: {
        valueSuffix: ' 円',
        valueDecimals: 0,
      },
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height,
      },
      plotOptions: {
        line: {
          color: '#FF0000',
          dashStyle: 'ShortDash',
        },
      },
    });

  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.dashboard/invoice_chart.controller.js